import { Link } from "react-router-dom";
import {
  BASE_URL,
  GOTOPRODUCTDETAILS_URL_LOCAL,
} from "../../../utility/BaseUrl";
import { formatNumber } from "../../../utility/Formater";
import { useState } from "react";
import { RemoveItemOrderService } from "../../../services/MainScreen";
import Swal from "sweetalert2";

export default function ShoppingBoxViewProductComponent({
  pro,
  item,
  setData,
}) {
  const {
    product_cover,
    product_cover_alt,
    product_cover_title,
    product_model,
    product_name,
    is_active,
    slug,
    id,
  } = pro;

  const {
    color,
    final_price,
    product_purchase_price,
    interest_percent,
    product_sales_price,
    discount_percent,
    quantity,
  } = pro.inventory_of_product;

  const [loadingDelete, setLoadingDelete] = useState(false);

  const handleDeleteProduct = async () => {
    setLoadingDelete(true);
    const showNotification = (icon, title, text, position = "top-end") => {
      Swal.fire({
        icon,
        title,
        text,
        timer: 2000,
        showConfirmButton: false,
        position,
        toast: true,
      });
    };

    try {
      const result = await Swal.fire({
        title: "آیا مطمئن هستید؟",
        text: "این آیتم از سبد خرید شما حذف خواهد شد.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بله، حذف شود!",
        cancelButtonText: "لغو",
      });

      if (!result.isConfirmed) return;

      const responseCart = await RemoveItemOrderService(item.id);

      if (responseCart.status === 0) {
        return showNotification(
          "error",
          "خطا",
          "خطا در پاک کردن یک محصول از سبد."
        );
      }

      const { items, id, is_finished, total } = responseCart.result;
      setData((prevState) => ({
        ...prevState,
        user: {
          ...prevState.user,
          cart: { id, items, is_finished, total },
        },
      }));

      showNotification(
        "success",
        "موفقیت",
        responseCart.message,
        "center-center"
      );
    } catch {
      showNotification("error", "خطا", "خطا در کاهش محصول از سبد.");
    } finally {
      setLoadingDelete(false);
    }
  };

  return (
    <form name="items" className="cart-item ">
      <hr className="page-separator cart-separator" />
      <div className="row">
        <div className="col-6 col-md-4 col-lg-3 col-xl-2">
          <div className="d-flex align-items-center h-100">
            <div className="cart-item-image w-100">
              <Link
                to={GOTOPRODUCTDETAILS_URL_LOCAL(slug)}
                className="cart-item-image-link"
              >
                <img
                  className="img-responsive cart-item-image-element"
                  src={BASE_URL + product_cover}
                  title={product_cover_title}
                  alt={product_cover_alt}
                />
              </Link>
            </div>
          </div>
        </div>
        <div className="col-6 col-md-4 col-lg-3 col-xl-4">
          <div className="d-flex align-items-center h-100">
            <div className="cart-item-details w-100">
              <h5 className="cart-item-title">
                <Link
                  to={GOTOPRODUCTDETAILS_URL_LOCAL(slug)}
                  className="cart-item-link"
                >
                  {product_name}
                </Link>
              </h5>
              <div className="cart-item-subtitle ">{product_model}</div>
              {discount_percent > 0 ? (
                <div className="cart-item-subtitle badge bg-danger rounded">
                  % {discount_percent}{" "}
                </div>
              ) : null}
              {pro.brand ? (
                <div className="cart-item-id ">
                  برند : {pro.brand.brand_name}
                </div>
              ) : null}
            </div>
          </div>
        </div>
        <div className="col-md-4 col-lg-3 col-xl-3">
          <div className="d-flex align-items-center h-100 pr-md-30 cart-col">
            <div className="cart-item-amounts w-100">
              <div className="cart-item-quantity">
                <div className="input-group input-group-sm cart-item-quantity-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">تعداد</span>
                  </div>
                  <input
                    type="number"
                    name="quantity"
                    className="form-control cart-item-quantity-input "
                    value={item.qty}
                    min={1}
                    max={2}
                  />
                </div>
              </div>
              <div className="cart-item-price">
                قیمت :{" "}
                {discount_percent > 0 ? (
                  <span className="cart-item-price-compare  ">
                    {formatNumber(product_sales_price)}
                  </span>
                ) : null}
                <span className="cart-item-price-value ">
                  {formatNumber(final_price)}
                </span>
              </div>
              {/* <div className="cart-item-shipping">
                                          حمل و نقل:
                                        </div>
                                        <div className="cart-item-tax">
                                          مالیات: 9 %
                                        </div> */}
              <button
                type="button"
                className="badge badge-danger cart-item-remove text-white border-0"
                onClick={handleDeleteProduct}
              >
                <i
                  className={
                    "fa fa-fw fa-times" + (loadingDelete ? " d-none" : "")
                  }
                />
                <i
                  className={
                    "fa fa-fw fa-refresh fa-spin " +
                    (!loadingDelete ? " d-none" : "")
                  }
                />
                حذف
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-xl-3">
          <div className="d-flex align-items-center h-100 pr-md-30 cart-col">
            <div className="cart-item-subtotal ">
              <h6 className="cart-item-subtotal-title">جمع</h6>
              {formatNumber(item.pay_amount)} تومان
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}
